import { z } from 'zod';

/**
 * UI-layer Zod schema for checkout form fields — distinct from the wire
 * `placeOrderRequestSchema`. Shared between web and mobile to avoid duplication.
 */
export const checkoutFormSchema = z.object({
  fulfillment: z.enum(['PICKUP', 'RESTAURANT_DELIVERY']),
  paymentProviderId: z.string().min(1),
  guestEmail: z.string().email().optional().or(z.literal('')),
  guestPhone: z.string().min(5).optional().or(z.literal('')),
  guestDisplayName: z.string().min(1).optional().or(z.literal('')),
  addressLine1: z.string().optional(),
  addressCity: z.string().optional(),
  notes: z.string().max(2000).optional(),
});

export type CheckoutFormValues = z.infer<typeof checkoutFormSchema>;
